/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SignerType {
  HIRER_COMPANY_MEMBER = 'HIRER_COMPANY_MEMBER',
  HIRER_WITNESS = 'HIRER_WITNESS',
  PROFESSIONAL_COMPANY_MEMBER = 'PROFESSIONAL_COMPANY_MEMBER',
}
